export default __webpack_public_path__ + "static/media/TDABanner.eec7cbe9.jpg";